import { Route, Routes, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ThreeDots } from "react-loader-spinner";
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary";

import { UserRoles } from "./utils/enums/global.enum";

const Home = lazy(() => import("./pages/Home/Home"));


const AccessDenied = lazy(
  () => import("./pages/NoAccess/NoAccess")
);

const suspenseFallback = (
  <div className="three-dot-fallback">
    <ThreeDots height="80" width="80" color="#40BBBD" />
  </div>
);

function routeElement(Component: any, roleId: number, UserRoles: any) {
  return (
    <Suspense fallback={suspenseFallback}>
        <Component />
     
    </Suspense>
  );
}

export default function RouteDefinitions({ roleId }: any) {
  const routeDefinition = (
    <Routes>
      {/* <Route path="/accessdenied" element={<AccessDeniedPage />} />
      <Route path="/login" element={<Login />} /> */}
      {roleId !== "" && (
        <>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/accessDenied" element={<AccessDenied />} />
        </>
      )}
    </Routes>
  );

  //const routes = createBrowserRouter(routeDefinition);

  return (
    <ErrorBoundary>
      <Suspense fallback={suspenseFallback}>
        {routeDefinition}
        {/* <RouterProvider router={routes}></RouterProvider> */}
      </Suspense>
    </ErrorBoundary>
  );
}
